"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UpperCase = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M7.92967117,6.63093052 L11.9287427,16.6286093 C12.4108096,17.7587986 10.6323903,18.6137688 10.0717893,17.3713907 L9.123,14.9997491 L4.877,14.9997491 L3.9287427,17.3713907 C3.32009305,18.6385803 1.62353516,17.7799072 2.07178932,16.6286093 L6.07086084,6.63093052 C6.41018677,5.81597025 7.57164001,5.77110291 7.92967117,6.63093052 Z M18.9296712,6.63093052 L22.9287427,16.6286093 C23.4108096,17.7587986 21.6323903,18.6137688 21.0717893,17.3713907 L20.123,14.9997491 L15.877,14.9997491 L14.9287427,17.3713907 C14.3200931,18.6385803 12.6235352,17.7799072 13.0717893,16.6286093 L17.0708608,6.63093052 C17.4101868,5.81597025 18.57164,5.77110291 18.9296712,6.63093052 Z M7.00026601,9.6925824 L5.677,12.9997491 L8.323,12.9997491 L7.00026601,9.6925824 Z M18.000266,9.6925824 L16.677,12.9997491 L19.323,12.9997491 L18.000266,9.6925824 Z" })));
};
UpperCase.displayName = 'UpperCase';
exports.default = UpperCase;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UpperCase.js.map